import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import HeroCollage from "@/components/HeroCollage";
import PhotoFeed from "@/components/PhotoFeed";
import FeaturedWeddings from "@/components/FeaturedWeddings";
import ReelsCarousel from "@/components/ReelsCarousel";
import MoodboardsGrid from "@/components/MoodboardsGrid";
import StoriesSection from "@/components/StoriesSection";
import AboutSection from "@/components/AboutSection";
import { api } from "@/lib/api";
import { useSettings } from "@/contexts/SettingsContext";

export default function Home() {
  const { settings } = useSettings();
  const [weddings, setWeddings] = useState([]);
  const [reels, setReels] = useState([]);
  const [moodboards, setMoodboards] = useState([]);
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get("/weddings", { params: { featured: true } }).then((r) => setWeddings(r.data)).catch(() => {});
    api.get("/reels", { params: { featured_home: true } }).then((r) => setReels(r.data)).catch(() => {});
    api.get("/moodboards", { params: { featured: true } }).then((r) => setMoodboards(r.data)).catch(() => {});
    api.get("/stories", { params: { featured: true } }).then((r) => setStories(r.data)).catch(() => {});
  }, []);

  const vis = settings.section_visibility || {};
  const order = settings.section_order || ["hero", "photofeed", "weddings", "reels", "moodboards", "stories", "about"];

  const sections = {
    hero: <HeroCollage key="hero" />,
    photofeed: <PhotoFeed key="photofeed" />,
    weddings: <FeaturedWeddings key="weddings" weddings={weddings} />,
    reels: <ReelsCarousel key="reels" reels={reels} />,
    moodboards: <MoodboardsGrid key="moodboards" moodboards={moodboards} />,
    stories: <StoriesSection key="stories" stories={stories} />,
    about: <AboutSection key="about" />,
  };

  return (
    <PublicLayout>
      {order.filter((k) => vis[k] !== false && sections[k]).map((k) => sections[k])}
    </PublicLayout>
  );
}
